import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import ElectionReminderStart from './ElectionReminderStart';
import ElectionReminderDetails from './ElectionReminderDetails';
import ElectionReminderSuccess from './ElectionReminderSuccess';

const ElectionReminder = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(electionReminder|electionReminder/start)"
                            name="ElectionReminderStart"
                            exact
                            component={ElectionReminderStart}
                        />
                        <Route
                            path="/electionReminder/details"
                            name="ElectionReminderDetails"
                            exact
                            component={ElectionReminderDetails}
                        />
                        <Route
                            path="/electionReminder/success"
                            name="ElectionReminderSuccess"
                            exact
                            component={ElectionReminderSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default ElectionReminder;



// WEBPACK FOOTER //
// ./src/containers/ElectionReminder/ElectionReminder.jsx